import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['Vous enseignez la physique-chimie et vous préparez régulièrement des séquences de chimie.', 'Vous souhaitez réduire le temps consacré à la recherche et à la préparation.', 'Vous cherchez des supports très visuels, prêts à imprimer ou à projeter.', 'Vous voulez séquences, activités, évaluations et corrigés au même endroit.'];
const notForYou = ['Vous cherchez une formation, un cours en vidéo ou une certification.', 'Vous préférez concevoir chaque schéma et chaque support par vous-même.', 'Vous attendez des ouvrages imprimés livrés à votre domicile.'];
export function AudienceSection() {
  return <section className="w-full bg-paper px-5 py-6 sm:py-12" data-id="element-24" data-mp="e2ed0gk8b3cz">
      <div className="mx-auto grid max-w-5xl gap-4 sm:gap-6 md:grid-cols-2" data-id="element-25" data-mp="3crbvpzs1ilg7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-cobalt/20 bg-[#EEF4FF] p-6 sm:p-8" data-id="element-26" data-mp="3hpwv5wzgx13l">
          <h3 className="mb-6 text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-27" data-mp="ukhhe4vfz0j0">
            CHIMIE VISUELLE™ est fait pour vous si…
          </h3>
          <ul className="space-y-4" data-id="element-28" data-mp="qiw7mse7f2d1">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-29" data-mp="llcigxfyx56b">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-30" data-mp="glhub1nkutoy">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-31" data-mp="bmwsixsog1ye" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-32" data-mp="7llbhgnvcp1t">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-ink/10 bg-white p-6 sm:p-8" data-id="element-33" data-mp="25xtnkmeobv8c">
          <h3 className="mb-6 text-lg font-bold text-ink sm:text-xl" data-id="element-34" data-mp="3mh581c516kr1">Ce n’est pas pour vous si…</h3>
          <ul className="space-y-4" data-id="element-35" data-mp="3qhp38a61neaj">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-36" data-mp="i2drjgcfxpd0">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ink/10 text-ink/60" data-id="element-37" data-mp="i2x2gd3obdhj">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-38" data-mp="mz443tp1e2to" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-39" data-mp="941scpxidj8y">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}